import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';

import { reducer } from './reducer';

@NgModule({
    imports: [
        CommonModule,
        StoreModule.forFeature('workshop-timer', reducer),
        EffectsModule.forFeature([]),
    ],
    providers: [],
})
export class WorkshopTimerStoreModule { }
